import { render, staticRenderFns } from "./UsersUpload.vue?vue&type=template&id=67097092&scoped=true&"
import script from "./UsersUpload.vue?vue&type=script&lang=js&"
export * from "./UsersUpload.vue?vue&type=script&lang=js&"
import style0 from "./UsersUpload.vue?vue&type=style&index=0&id=67097092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67097092",
  null
  
)

export default component.exports